import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';
import classes from './FinalBannerAfterPublishFinalWinners.module.css';

const FinalBannerAfterPublishFinalWinners = () => {
  const { texts, lang } = useSelector((state) => state.translate);
  const { contentInfoJson } = useSelector((state) => state.contest);

  const poduim = contentInfoJson?.final?.poduim ?? [];

  return (
    <BannerTopComponent title={texts.finalBannerTitle} colorBackground="none">
      <div className={classes.imagesContainer}>
        <img src={poduim[0]?.src?.[lang]} alt={poduim[0]?.alt || ''} className={classes.bannerWrapper1350} />
        <img src={poduim[1]?.src?.[lang]} alt={poduim[1]?.alt || ''} className={classes.bannerWrapper1075} />
        <img src={poduim[2]?.src?.[lang]} alt={poduim[2]?.alt || ''} className={classes.bannerWrapper800} />
        <img src={poduim[3]?.src?.[lang]} alt={poduim[3]?.alt || ''} className={classes.bannerWrapper525} />
      </div>
    </BannerTopComponent>
  );
};

export default FinalBannerAfterPublishFinalWinners;